import { post, getJson } from '@/api/http';


/** 获取敏感词列表 */

export const sensitivewords = (params, token) => getJson(`${config.cpp}monitor/v1/sensitivewords`, params, { token })
/** 添加敏感词 */

export const sensitivewordsAdd = (data, token) => post(`${config.cpp}monitor/v1/sensitivewords/add`, data, { token })
/** 删除敏感词 */

export const sensitivewordsDel = (data, token) => post(`${config.cpp}monitor/v1/sensitivewords/del`, data, { token })